export type PlayerVisibility = "live" | "coming_soon" | "hidden";

export interface GameEnabledRow {
    game_name: string;
    is_enabled: boolean;
    player_visibility?: PlayerVisibility | string | null;
}

export function readPlayerVisibility(row?: GameEnabledRow | null): PlayerVisibility {
    const raw = String(row?.player_visibility || "").toLowerCase();
    if (raw === "coming_soon") return "coming_soon";
    if (raw === "hidden") return "hidden";
    if (raw === "live") return "live";
    if (row?.is_enabled) return "live";
    const gameName = String(row?.game_name || "").toLowerCase();
    if (gameName === "bullion" || gameName === "sixes") return "coming_soon";
    return "hidden";
}


export function resolveTeaserGameState(row?: GameEnabledRow | null) {
    return resolvePlayerGameState(row);
}

export function resolvePlayerGameState(row?: GameEnabledRow | null) {
    if (!row) {
        return { visible: false, live: false, comingSoon: false };
    }
    const visibility = readPlayerVisibility(row);
    if (visibility === "hidden") {
        return { visible: false, live: false, comingSoon: false };
    }
    const live = Boolean(row?.is_enabled);
    if (visibility === "coming_soon") {
        return { visible: true, live: false, comingSoon: true };
    }
    return { visible: true, live, comingSoon: !live };
}

export function playerStatusLabel(status: string): "Live" | "Coming soon" | "Hidden" {
    if (status === "Coming soon" || status === "Hidden") return status;
    return "Live";
}

export function playerStatusTone(status: string): "success" | "neutral" {
    return status === "Live" ? "success" : "neutral";
}

export function nextPlayerVisibility(game: {
    player_visibility: PlayerVisibility;
    supports_coming_soon?: boolean;
}): PlayerVisibility {
    if (game.supports_coming_soon) {
        if (game.player_visibility === "live") return "coming_soon";
        if (game.player_visibility === "coming_soon") return "hidden";
        return "live";
    }
    return game.player_visibility === "live" ? "hidden" : "live";
}

export function visibilityActionLabel(nextVisibility: PlayerVisibility) {
    if (nextVisibility === "live") return "Set live";
    if (nextVisibility === "coming_soon") return "Set coming soon";
    return "Set hidden";
}

export function visibilitySummaryLabel(visibility: PlayerVisibility) {
    if (visibility === "live") return "Live";
    if (visibility === "coming_soon") return "Coming soon";
    return "Hidden";
}
